import { Component, inject } from '@angular/core';
import { FsthpMasterDataStore } from '../services/fsthp-master-data.store';

@Component({
  selector: 'app-copy-right',
  imports: [],
  templateUrl: './copy-right.component.html',
  styleUrl: './copy-right.component.scss',
})

/**
 * コピーライトコンポーネント
 */
export class CopyRightComponent {
  private readonly masterDataStore = inject(FsthpMasterDataStore);

  getRegistrationNo(): string {
    return this.masterDataStore.getRegistrationNo();
  }
}
